import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: "root",
  })


export class ActivityService {
constructor(private http: HttpClient){}

    public getList(request) {
               return this.http.post<any>("/UserDashboard/GetNewAndReturningUsers", request);
      }
  }